Vue.component('tournamentsQueue', {
    template: templates.tournamentsQueue,
    data() {
      return {
        model: {
          queues: [],
          hasResults: false,
        },
        cancelTokenSource: null
      };
    },
    mounted() {
      const c = this;
      c.get();
      c.connect();
    },
    beforeDestroy() {
      const c = this;
  
      if (c.ws) {
        c.ws.close();
      }
      
      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Request canceled due to component destruction.');
      }
    },
    methods: {
      connect() {
        const c = this;
        c.ws = new WebSocket(utils.getWsUrl());
  
        c.ws.onmessage = (event) => {
  
          const messageData = event.data;
  
          try {
  
            const parsedData = JSON.parse(messageData);
             if(parsedData.to === utils.cookies.get('user_id')){
              c.get();
            }
  
          } catch (error) {
            console.error('Error parsing message data:', error);
          }
        
        };
  
        c.ws.onopen = () => {
          console.log('WebSocket connection established');
        };
  
        c.ws.onclose = () => {
          console.log('WebSocket connection closed');
        };
      },
      get() {
        const c = this;
  
        tournamentService
          .getTournamentQueue()
          .then((res) => {
            c.model.hasResults = true;
            c.model.queues = res.data;
          })
          .catch((err) => {
            c.model.hasResults = false;
          });
      },
  
   
    },
  });
  